var Control = require("enyo/Control"),
    kind    = require("enyo/kind"),
    master  = require("enyo/master");

require("enyo-ui");

/**
 * [FloatingSupport]{@link enyo-ui.FloatingSupport} allows a control to be
 * rendered into the floating layer.
 *
 * @mixin enyo-ui.FloatingSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.FloatingSupport",

    /**
     * Whether the control is to be rendered in the floating layer.
     *
     * @name     floating
     * @type     {boolean}
     * @default  true
     * @memberof enyo-ui.FloatingSupport
     * @public
     */

    /**
     * @memberof enyo-ui.FloatingSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            // Default to floating
            if (this.floating === undefined) {
                this.floating = true;
            }

            if (this.floating) {
                this.floatingChanged(false);
            }
        };
    }),

    /**
     * @param  {boolean}  wasFloating  Whether the control was floating before.
     * @memberof enyo-ui.FloatingSupport
     * @method
     * @private
     */
    floatingChanged: function(wasFloating) {
        var isFloating = this.floating,
            owner      = this.owner;

        // Make sure the floatingLayer will waterfall events to us, while still
        // bubbling our own events to our owner.
        if (!wasFloating && isFloating) {
            Control.floatingLayer.addChild(this, this.addBefore);
            this.set("bubbleTarget", owner);
        }

        // Re-attach to owner and stop overriding bubble target.
        if (wasFloating && !isFloating) {
            if (owner !== master) {
                owner.addChild(this);
            }
            else {
                Control.floatingLayer.removeChild(this);
                this.set("parent", null);
            }
            this.set("bubbleTarget", null);
        }

        // Set a css flag and re-render in new parent.
        if (wasFloating !== isFloating) {
            this.addRemoveClass("floating", isFloating);
            this.hasNode() && this.render();
        }
    },

    /**
     * Ensures the control gets rendered into the floating layer if `floating`
     * is `true`.
     *
     * @memberof enyo-ui.FloatingSupport
     * @method
     * @private
     */
    render: kind.inherit(function(sup) {
        return function() {
            if (this.floating) {
                if (!Control.floatingLayer.hasNode()) {
                    Control.floatingLayer.render();
                }
                this.parentNode = Control.floatingLayer.hasNode();
            }
            sup.apply(this, arguments);
        };
    }),

    /**
     * Make sure the node is removed from the floating layer if needed.
     * @memberof enyo-ui.FloatingSupport
     * @method
     * @private
     */
    teardownRender: kind.inherit(function(sup) {
        return function() {
            // If this is a floating Control, remove the node from the floating
            // layer because it won't be removed otherwise.
            if (this.floating) {
                this.removeNodeFromDom();
            }

            sup.apply(this, arguments);
        };
    }),

    /**
     * @memberof enyo-ui.FloatingSupport
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.floating) {
                Control.floatingLayer.removeChild(this);
                this.set("parent", null);
                this.set("bubbleTarget", null);
            }
        };
    })

};
